function loadPertukaranPel(view) {
    return () => import( /* webpackChunkName: "pertukaranpel-[request]" */ `../../views/KampusMerdeka/PertukaranPel/${view}.vue`)
}

const route = [
  // ##REGION SUPERADMIN
    // (Superadmin) Universitas Tujuan
      {
        path: '/kampus-merdeka/pertukaran-pelajar/superadmin/university', //bebas
        name: 'UniversityDestination', //bebas
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
        },
      component: loadPertukaranPel('UniversityDestination') //menyesuaikan nama component
      },
    // (Superadmin) Studi Program Tujuan
      {
          path: '/kampus-merdeka/pertukaran-pelajar/superadmin/studyprogram-destination',
          name: 'StudyProgramDestination', 
          meta: {
          requiresAuth: true,
          roleVerif: false,
          role: []
          },
        component: loadPertukaranPel('StudyProgramDestination')
      },

  // ##REGION PRODI
    // (Prodi) Program Studi Tujuan
      {
        path: '/kampus-merdeka/pertukaran-pelajar/prodi/studyprogram-destination',
        name: 'StudyProgramProdiDestination',
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
        },
      component: loadPertukaranPel('StudyProgramProdiDestination')
      },
    // (Prodi) Verifikasi Pendaftaran Pertukaran Pelajar
      {
        path: '/kampus-merdeka/pertukaran-pelajar/prodi/verify-registration',
        name: 'StudentExchangeVerify',
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
        },
      component: loadPertukaranPel('StudentExchangeVerify')
      },
    // (Prodi) Verifikasi Pengajuan Penolakan Pertukaran Pelajar
      {
        path: '/kampus-merdeka/pertukaran-pelajar/prodi/verify-rejection/:id',
        name: 'RejectionViewProdi',
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
        },
      component: loadPertukaranPel('RejectionViewProdi')
      },
    // (Prodi) Verifikasi Nilai Pertukaran Pelajar
      {
        path: '/kampus-merdeka/pertukaran-pelajar/prodi/verify-grade',
        name: 'StudentExchangeVerifyExam',
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
        },
      component: loadPertukaranPel('VerifyExamStudentExchange')
      },

    // (Prodi) Kuota Pertukaran Pelajar
    {
      path: '/kampus-merdeka/pertukaran-pelajar/prodi/quota/:id',
      name: 'StudyCourseQuota',
      meta: {
      requiresAuth: true,
      roleVerif: false,
      role: []
      },
    component: loadPertukaranPel('StudyCourseQuota')
    },
    //(prodi) Mengambil semua penolakan Pertukaran Pelajar
    {
      path: '/kampus-merdeka/pertukaran-pelajar/prodi/get-rejection',
      name: 'StudentExchangeRejection',
      meta: {
      requiresAuth: true,
      roleVerif: false,
      role: []
      },
    component: loadPertukaranPel('StudentExchangeRejection')
    },

  // ##REGION ADMINISTRATOR
    // (administrator) Verifikasi Pertukaran Pelajar
    {
      path: '/kampus-merdeka/pertukaran-pelajar/admin/verify-grade',
      name: 'StudentExchangeVerifyExamTU',
      meta: {
      requiresAuth: true,
      roleVerif: false,
      role: []
      },
    component: loadPertukaranPel('VerifyExamStudentExchangeTU')
    },

  // ##REGION MAHASISWA
    // (mahasiswa) Pendaftaran Pertukaran Pelajar 
      {
        path: '/kampus-merdeka/pertukaran-pelajar/mahasiswa/main',
        name: 'StudentExchangeMain',
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
        },
      component: loadPertukaranPel('StudentExchangeMain')
      },
    // (mahasiswa) Penawaran Mata Kuliah
      {
        path: '/kampus-merdeka/pertukaran-pelajar/mahasiswa/studycourse-student',
        name: 'StudyCourseExcStudent',
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
        },
      component: loadPertukaranPel('StudyCourseExcStudent')
      },
    // (mahasiswa) Pengajuan penolakan Pertukaran Pelajar
    {
      path: '/kampus-merdeka/pertukaran-pelajar/mahasiswa/rejection-form/:id',
      name: 'RejectionViewMahasiswa',
      meta: {
      requiresAuth: true,
      roleVerif: false,
      role: []
      },
    component: loadPertukaranPel('RejectionViewMahasiswa')
    },

  // ##REGION SUPERADMIN X PRODI
    //Mata Kuliah Pertukaran
      {
        path: '/kampus-merdeka/pertukaran-pelajar/master/studycourse-exchange',
        name: 'StudyCourseExc',
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
        },
      component: loadPertukaranPel('StudyCourseExc')
      }
]

export default route

